import classNames from 'classnames';
import React from 'react';
import { useVideoConfig } from '../../video/video-config-provider';
import s from './icon-button.scss';
export const IconButton = ({ dataHook, className, Icon, onClick }) => {
    const { mobile } = useVideoConfig();
    return (React.createElement("button", { "data-hook": dataHook, className: classNames(s.container, className, { [s.mobile]: mobile }), onClick: onClick },
        React.createElement(Icon, { size: 16 })));
};
//# sourceMappingURL=icon-button.js.map